import { render, staticRenderFns } from "./SManagerpurchase.vue?vue&type=template&id=01faf5d7"
import script from "./SManagerpurchase.vue?vue&type=script&lang=js"
export * from "./SManagerpurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports